// extracted by mini-css-extract-plugin
export default {"h1":"PartnerClubsAndBranchesOfKFTPage_h1__Jrmbv","h3":"PartnerClubsAndBranchesOfKFTPage_h3__NcfAl","hr":"PartnerClubsAndBranchesOfKFTPage_hr__1k3yk"};